var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1004.61 152.96L1005.47 153.111L1004.57 153.926L998.947 293.809L976.933 314.67L968.62 758.523L699.439 1005.43L699.413 1006.23L698.73 1006.09L698.13 1006.63L698.149 1005.96L74.589 872.379L62.053 393.624L34.606 387.024L32.418 234.285L31.109 234L32.403 233.222L32.389 232.222L33.625 232.488L356.047 38.652L1004.21 152.889L1004.63 152.533L1004.61 152.96Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M966.627 147.288L967.443 147.431L966.59 148.209L961.234 281.49L940.269 301.366L932.352 724.273L676.002 959.537L675.978 960.296L675.327 960.157L674.759 960.678L674.78 960.044L80.937 832.756L68.998 376.594L42.86 370.304L40.78 224.775L39.533 224.503L40.765 223.762L40.751 222.81L41.928 223.063L348.98 38.375L966.248 147.221L966.648 146.881L966.627 147.288Z",
    stroke: "url(#paint0_linear_66_2)",
    strokeWidth: 72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M966.627 147.288L967.443 147.431L966.59 148.209L961.234 281.49L940.269 301.366L932.352 724.273L676.002 959.537L675.978 960.296L675.327 960.157L674.759 960.678L674.78 960.044L80.937 832.756L68.998 376.594L42.86 370.304L40.78 224.775L39.533 224.503L40.765 223.762L40.751 222.81L41.928 223.063L348.98 38.375L966.248 147.221L966.648 146.881L966.627 147.288Z",
    stroke: "url(#paint1_linear_66_2)",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941.48 237.469L932.348 725.287L674.755 961.687L688.088 479.151L941.48 237.469Z",
    fill: "url(#paint2_linear_66_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M691.595 479.186L675.98 961.31L80.937 833.77L67.897 335.51L691.595 479.186Z",
    fill: "url(#paint3_linear_66_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.957 191.305L941.307 320.98L687.241 564.944L687.08 564.911L70.729 417.93L63.303 293.875L698.741 417.269L942.957 191.305Z",
    fill: "#0C0303"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M966.643 147.896L961.234 282.504L702.587 529.623L705.119 370.564L966.643 147.896Z",
    fill: "#D53928"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 702,
    y: 147,
    width: 265,
    height: 383
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M966.643 147.896L961.234 282.504L702.587 529.623L705.119 370.564L966.643 147.896Z",
    fill: "#D53928"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M919 175L913.911 340.488M862 391L867.238 221.454",
    stroke: "#F18746",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.056 371.263L703.316 529.778L42.8601 371.318L40.748 223.824L710.056 371.263Z",
    fill: "#D86831"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_66_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 223,
    width: 671,
    height: 307
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.056 371.263L703.316 529.778L42.8601 371.318L40.748 223.824L710.056 371.263Z",
    fill: "#D86831"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_66_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.562 512.724L629.932 347.347M571.257 334.752L564.448 501.234M488.309 481.844L493.971 318.744",
    stroke: "#F8A84B",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.443 148.444L710.407 375.577L39.5291 225.518L348.98 39.389L967.443 148.444Z",
    fill: "url(#paint4_linear_66_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.78 725.844L268.78 746.844L211.78 735.844L212.78 805.844L189.78 820.844L158.78 812.844L147.78 526.844L168.78 510.844L263.78 514.229L285.78 537.844L310.78 587.844L313.78 683.844L294.78 725.844ZM265.78 587.844L205.78 574.844L208.78 664.844L260.78 674.844L276.78 652.844L277.78 612.844L265.78 587.844ZM315.78 614.844L316.78 564.844L338.78 547.844L457.358 554.914L479.78 578.844L478.78 629.844L457.78 645.844L426.78 638.844L424.78 848.844L402.78 865.844L369.78 855.844L368.78 624.844L315.78 614.844ZM483.78 652.844L482.78 723.844L503.78 776.844L575.78 791.844L583.78 811.844V825.844L578.78 833.844L501.78 817.844L480.78 834.844L478.78 881.844L590.78 906.844L620.78 883.844L636.78 848.844L639.78 783.844L616.78 731.844L595.358 708.444L543.78 716.844L536.78 691.844L537.78 662.844L623.78 682.844L644.78 666.844L648.78 615.844L625.461 592.944L529.78 590.844L508.78 606.844L483.78 652.844Z",
    fill: "#813521"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.78 701.844L246.78 722.844L189.78 711.844L190.78 781.844L167.78 796.844L136.78 788.844L125.78 502.844L146.78 486.844L263.78 513.844L288.78 563.844L291.78 659.844L272.78 701.844ZM243.78 563.844L183.78 550.844L186.78 640.844L238.78 650.844L254.78 628.844L255.78 588.844L243.78 563.844ZM293.78 590.844L294.78 540.844L316.78 523.844L457.78 554.844L456.78 605.844L435.78 621.844L404.78 614.844L402.78 824.844L380.78 841.844L347.78 831.844L346.78 600.844L293.78 590.844ZM461.78 628.844L460.78 699.844L481.78 752.844L553.78 767.844L561.78 787.844V801.844L556.78 809.844L479.78 793.844L458.78 810.844L456.78 857.844L568.78 882.844L598.78 859.844L614.78 824.844L617.78 759.844L594.78 707.844L521.78 692.844L514.78 667.844L515.78 638.844L601.78 658.844L622.78 642.844L626.78 591.844L507.78 566.844L486.78 582.844L461.78 628.844Z",
    fill: "#F18746"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.18 784.944L165.115 791.644L163.515 702.363L244.98 719.174L265.873 678.206L264.068 581.806L240.787 532.32L128.667 506.644L139.18 784.944ZM161.415 660.122L157.396 559.91L226.628 575.237L237.58 598.944L239.38 653.993L229.345 673.737L161.415 660.122ZM296.773 587.344L348.973 598.623L350.043 830.042L377.749 837.163L379.691 605.607L432.206 617.307L432.825 573.607L297.597 544.221L296.773 587.344ZM487.68 585.995L464.391 629.002L462.407 698.866L483.671 749.949L555.314 764.657L565.197 789.057L564.556 814.286L552.61 834.036L460.499 814.384L458.607 854.82L567.507 878.932L590.645 840.766L594.483 776.426L574.636 727.186L500.628 709.286L490.398 683.001L491.291 653.48L503.229 633.533L598.345 655.002L601.051 610.312L487.68 585.995Z",
    fill: "#FFF18D",
    stroke: "#FFF18D",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_2",
    x1: 503.483,
    y1: 960.688,
    x2: 503.483,
    y2: 38.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF811F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_2",
    x1: 503.483,
    y1: 960.688,
    x2: 503.483,
    y2: 38.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF18C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_2",
    x1: 941.499,
    y1: 797.315,
    x2: 674.749,
    y2: 401.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#862821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_66_2",
    x1: 499.862,
    y1: 335.5,
    x2: 259.635,
    y2: 961.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D55C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A93A23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_66_2",
    x1: 503.483,
    y1: 375.563,
    x2: 503.483,
    y2: 39.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoints);
export default __webpack_public_path__ + "static/media/icon-points.afa2ea8f5e71cd762da5afc7512e1047.svg";
export { ForwardRef as ReactComponent };